var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebhooks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 11a2 2 0 0 1 2 2H7a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h1v1H5l-.204-.01A2 2 0 0 1 5 11z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.204 11.01A2 2 0 0 1 9 15H8a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2H8v-1h1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 1a5 5 0 0 1 4.7 3.297 5.001 5.001 0 0 1-.406 9.532l-.259-.966a4 4 0 1 0-2.071-7.727l-.259-.967a5 5 0 0 1 1.769-.147A4 4 0 0 0 8 2a4 4 0 0 0-4 4c1.105 0 2.104.448 2.828 1.172l-.707.707a3 3 0 0 0-4.26 4.222l-.715.7a4.002 4.002 0 0 1 1.855-6.677l-.001-.124a5 5 0 0 1 5-5"
})));
export default SvgWebhooks;